import MainLayout from "../Common/MainLayout";
import SideBar from "./SideBar";
import { Outlet } from "react-router-dom";
import "./GenericTemplate.css"; // Create a CSS file for consistent layout styles

// This component serves as a template for the page consists of a sidebar with menu items and an outlet for nested routes.
// It is used to maintain a consistent layout across different pages.  

const GenericTemplate = ({ menuItems }) => {
  return (
    <MainLayout>
      <div className="generic-template-container">
        <SideBar items={menuItems} />
        <div className="generic-template-content">
          <Outlet />
        </div>
      </div>
    </MainLayout>
  );
};

export default GenericTemplate;